import cn from 'classnames';
import { CSSProperties, memo, useState } from 'react';

import Loader from '../SVGIcons/Loader';
import classes from './main-header-title.module.scss';

type MainHeaderTitleProps = {
  className?: string;
  style?: CSSProperties;
  bgImage?: string| undefined;
};

function MainHeaderTitle({ className, style, bgImage }: MainHeaderTitleProps) {
  const [isLoadingImage, setLoadingImage] = useState(true);

  return (
    <div
      className={cn(classes['main-header-title'], className)}
      style={style}
    >
      {isLoadingImage && (
        <div className={classes.loader}>
          <Loader />
        </div>
      )}

      {bgImage
        && (
        <img
          src={bgImage}
          draggable="false"
          alt="header background"
          className={cn(classes['main-header-title__background-image'], {
            [classes['main-header-title__background-image-isLoading']]: isLoadingImage,
          })}
          onLoad={() => setLoadingImage((prev) => !prev)}
        />
        )}
    </div>
  );
}

export default memo(MainHeaderTitle);
